import {makeAutoObservable} from 'mobx';
import {endpoints, types} from 'main/tools';
import {DomainStore} from 'shared/store';
import {EmployeeGroup} from 'main/stores/employee_groups';
import {Segment} from 'main/stores/segmentation';
import _ from 'lodash';

class CustomFieldGroupListState {
  store = new DomainStore();
  action;

  editingEmployeeGroup = {};
  editEmployeeGroupModalOpen = false;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({action}) {
    this.action = action;
  }

  setInteractiveAgent(agent) {
    this.interactiveAgent = agent;
  }

  async load() {
    if (this.action === 'new') {
      this.openAddEmployeeGroupModal();
    }
  }

  openAddEmployeeGroupModal() {
    const employeeGroup = new EmployeeGroup({segment: new Segment()});
    this.openEditEmployeeGroupModal(employeeGroup);
  }

  openEditEmployeeGroupModal(employeeGroup) {
    this.errors = {};
    this.editingEmployeeGroup = new EmployeeGroup(employeeGroup);
    this.editEmployeeGroupModalOpen = true;
  }

  closeEditEmployeeGroupModal() {
    this.editEmployeeGroupModalOpen = false;
  }

  filterEmptyRules() {
    this.editingEmployeeGroup.segment.rules = _.reject(this.editingEmployeeGroup.segment.rules, r => _.isEmpty(r.parameters) && r.ruleType !== 'all_employees');
  }

  async saveEmployeeGroup() {
    this.filterEmptyRules();

    const {model, errors} = this.editingEmployeeGroup.isNew ?
      await this.store.post(endpoints.EMPLOYEE_GROUPS, types.EMPLOYEE_GROUP, this.editingEmployeeGroup) :
      await this.store.patch(this.editingEmployeeGroup);

    this.errors = errors;

    if (model) {
      this.interactiveAgent.refresh();
      this.closeEditEmployeeGroupModal();
    }
  }

  async destroyEmployeeGroup(employeeGroup) {
    await this.store.destroy(employeeGroup);
  }
}

export default CustomFieldGroupListState;
